import { getGrowthBookConfigLoader } from '@doxyme/config';
import {
  UserPlanType,
  type UseUserSubscriptionReturnType,
} from './useUserSubscription.types';
import { useUserSubscription as useLegacyUserSubscription } from './useUserSubscription';
import { useUserEntitlementsContext } from '../../context';
import { UserEntitlementsContextType } from '../../context/userEntitlementsContext.types';

export const useUserSubscription = ():
  | UserEntitlementsContextType
  | UseUserSubscriptionReturnType => {
  const isFronteggEntitlementsEnabled =
    getGrowthBookConfigLoader().getOptional(
      'feat_prod_2316_frontegg_entitlements_enabled',
    ) === true;

  const entitlementsResult = useUserEntitlementsContext();
  const legacyResult = useLegacyUserSubscription();

  if (isFronteggEntitlementsEnabled) {
    if (
      !entitlementsResult.hasProPlanSubscription &&
      legacyResult.userPlanType === UserPlanType.Clinic
    ) {
      return {
        ...entitlementsResult,
        isUpgradeButtonVisible: false,
        isSubscriptionTabVisible: false,
      };
    }
    return entitlementsResult;
  }

  // Fall back to legacy subscription logic
  return legacyResult;
};
